import React, { useState, useEffect, useContext } from "react";
import Layout from "components/sales/layout/layout";
import Images from "assets/images/imageData";
import Proposition from "components/sales/formSection/proposition/proposition";
import OtherDetail from "components/sales/formSection/otherDetail/otherDetail";
import { Button } from "react-bootstrap";
import localization from "assets/localization/localization";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";

const B2bAlliance = ({
  locationCity,
  cities,
  dropDownData,
  getDropDownData,
  submitB2bData,
  match,
  documentUploadUrl,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const allianceInput = {
    proposition: null,
    other: null,
  };
  const [allianceData, setAllianceData] = useState(allianceInput);
  const [isModal, setIsModal] = useState(false);
  const [leadId, setleadId] = useState();

  const handleProposition = (val) => {
    setAllianceData({ ...allianceData, proposition: val });
  };
  const handleOther = (val) => {
    setAllianceData({ ...allianceData, other: val });
  };
  const handleSubmit = () => {
    const { proposition, other } = allianceData;
    const submitData = { ...proposition, ...other };
    if (proposition === null || other === null) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      (async () => {
        const res = await submitB2bData(submitData);
        if (res) {
          setIsModal(true);
        }
      })();
    }
  };
  useEffect(() => {
    if (match) setleadId(match.params.id);
    if (leadId) getDropDownData(leadId);
  }, [leadId]);
  const handleModalHide = () => setIsModal(false);

  useEffect(() => {
    (async () => {
      if (leadId) await getDropDownData(leadId);
    })();
  }, []);

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  return (
    <Layout
      title={localization.preSalesB2b}
      Buttons={headerBtns}
      className={isFiled ? "requiredFileds" : ""}
    >
      <Proposition
        handleValue={handleProposition}
        dropDownData={dropDownData}
        getDropDownData={getDropDownData}
        leadId={leadId}
        documentUploadUrl={documentUploadUrl}
      />
      <OtherDetail
        locationCity={locationCity}
        cities={cities}
        dropDownData={dropDownData}
        getDropDownData={getDropDownData}
        handleValue={handleOther}
      />
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.preB2bSuccess}</h5>
          <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.preSalesB2bList}{" "}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default B2bAlliance;
